const routes = [
  {
    path: '/smartPark',
    name: 'smartPark',
    component: () => import('./pages/Home'),
    // redirect: '/carAccessRecord/index',
    meta: {
      requireAuth: false
    },
    children: [
      {
        path: 'record', // 车辆记录
        name: 'smartParkRecord',
        component: () => import('./pages/Record'),
        meta: {
          requireAuth: false,
          routerAlive: true
        }
      },
      {
        path: 'manage', // 车辆管理
        name: 'smartParkManage',
        component: () => import('./pages/Manage'),
        meta: {
          requireAuth: false,
          routerAlive: true
        }
      },
      {
        path: 'control', // 车位管控
        name: 'smartParkControl',
        component: () => import('./pages/Control'),
        meta: {
          requireAuth: false,
          routerAlive: true
        }
      },
    ]
  }
]

export default routes